export const state = {
         logs: [
           {
             name: "contactLog",
             date: "2019-10-09T05:46:19.477Z",
             user: "John Doe",
             notes: "This"
           },
           {
             name: "contactLog",
             date: "2019-10-09T05:46:19.477Z",
             user: "Maria Doe",
             notes: "This"
           },
           {
             name: "contactLog",
             date: "2019-10-09T05:46:19.477Z",
             user: "Maria Doe",
             notes: "This"
           },
           {
             name: "contactLog",
             date: "2019-10-09T05:46:19.477Z",
             user: "Maria Doe",
             notes: "This"
           },
           {
             name: "contactLog",
             date: "2019-10-09T05:46:19.477Z",
             user: "Maria Doe",
             notes: "This"
           },
           {
             name: "contactLog",
             date: "2019-10-09T05:46:19.477Z",
             user: "Maria Doe",
             notes: "This"
           },
           {
             name: "contactLog",
             date: "2019-10-09T05:46:19.477Z",
             user: "Maria Doe",
             notes: "This"
           },
           {
             name: "contactLog",
             date: "2019-10-09T05:46:19.477Z",
             user: "Maria Doe",
             notes: "This"
           },
           {
             name: "paymentLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 50,
             comment: "Direct Debit Processed by Back Account"
           },
           {
             name: "paymentLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 100,
             comment: "Direct Debit Processed by Back Account"
           },
           {
             name: "paymentLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 100,
             comment: "Direct Debit Processed by Back Account"
           },
           {
             name: "paymentLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 100,
             comment: "Direct Debit Processed by Back Account"
           },
           {
             name: "paymentLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 100,
             comment: "Direct Debit Processed by Back Account"
           },
           {
             name: "paymentLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 100,
             comment: "Direct Debit Processed by Back Account"
           },
           {
             name: "paymentLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 100,
             comment: "Direct Debit Processed by Back Account"
           },
           {
             name: "paymentLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 100,
             comment: "Direct Debit Processed by Back Account"
           },
           {
             name: "paymentLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 100,
             comment: "Direct Debit Processed by Back Account"
           },
           {
             name: "creditLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 50
           },
           {
             name: "creditLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 50
           },
           {
             name: "creditLog",
             date: "2019-10-09T05:46:19.477Z",
             credit: 50
           }
         ],
         showNoteDialog: false
       };

export const mutations = {
	addRecord(state, newRecord){
		state.logs.push(newRecord);
	},
	changeStatus(){
		state.showNoteDialog = !state.showNoteDialog;
	}
};

export const getters = {
	logs: state => {
		return state.logs;
	},
	showNoteDialog: state => {
		return state.showNoteDialog;
	}
};

export const actions = {
	insertRecord({ commit }, newRecord) {
    // eslint-disable-next-line
		return new Promise((resolve, reject) => {
			commit("addRecord", newRecord);
			resolve(newRecord);
		});
	},
	updateNoteDialogStatus({ commit }){
    // eslint-disable-next-line
		return new Promise((resolve, reject) => {
			commit('changeStatus');
		});
	}
};
